import React from "react";
import { Icon, MenuItem } from "@material-ui/core";
import { IconMenu } from "js/react/components/UiComponents";

export function SortMenu({
    selectedField,
    sortOptions,
    onSetSort,
    disabled,
}) {
    return (
        <IconMenu disabled={disabled} icon="sort" iconButtonColor="primary">
            {sortOptions.map(({ field, direction, icon, label }) => (
                <MenuItem
                    key={field}
                    onClick={() => onSetSort({ field, direction })}
                    selected={field === selectedField}
                >
                    {icon && <Icon>{icon}</Icon>}
                    {label}
                </MenuItem>
            ))}
        </IconMenu>
    );
}

